/* tslint:disable */
/* eslint-disable */
/**
 * Opus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabel
 */
export interface MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabel {
  /**
   *
   * @type {string}
   * @memberof MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabel
   */
  text: string
}

/**
 * Check if a given object implements the MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabel interface.
 */
export function instanceOfMondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabel(
  value: object,
): value is MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabel {
  if (!('text' in value) || value['text'] === undefined) return false
  return true
}

export function MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabelFromJSON(
  json: any,
): MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabel {
  return MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabelFromJSONTyped(json, false)
}

export function MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabel {
  if (json == null) {
    return json
  }
  return {
    text: json['text'],
  }
}

export function MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabelToJSON(
  value?: MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusLabel | null,
): any {
  if (value == null) {
    return value
  }
  return {
    text: value['text'],
  }
}
